import * as React from "react";
import { FDocenteteInterface } from "../../../interfaces/FDocenteteInterface";
import { useTranslation } from "react-i18next";
import { LoadingButton } from "@mui/lab";
import { requestApi } from "../../../helpers/RequestApi";
import { PATCH } from "../../../utils/MethodUtils";
import { FDOCENTETES_URL } from "../../../utils/UrlsUtils";
import { toastr } from "react-redux-toastr";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { RootState } from "../../../app/store";
import { set } from "../../../app/globalSlice";
import getErrorApi from "../../../helpers/GetErrorApi";
import { ORDER_TYPE_PARTIAL } from "../../../utils/OrderUtils";
import { Box, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { canEditBonDeCommande } from "../../../helpers/FDocenteteHelper";
import { isUserBonDeCommande } from "../../../helpers/UserHelper";

interface State {
  fDocentete: FDocenteteInterface;
}

const FDocenteteParitalDeliveryComponent: React.FC<State> = React.memo(
  ({ fDocentete }) => {
    const token = useAppSelector((state: RootState) => state.globalState.token);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [loading, setLoading] = React.useState(false);
    const user = useAppSelector((state: RootState) => state.globalState.user);

    const partialOrder = React.useCallback(async () => {
      setLoading(true);
      const response = await requestApi({
        method: PATCH,
        path: FDOCENTETES_URL + "/" + fDocentete.doPiece + "/partial-livraison",
        allowError: true,
        token: token,
        body: {},
      });
      if (response.statusCode === 200) {
        dispatch(set({ refreshPage: true }));
      } else if (response.statusCode === 401) {
        toastr.info(t("word.info"), t("error.reconnect"));
      } else {
        for (let message of getErrorApi(response.content)) {
          toastr.error(t("word.error"), t(message));
        }
      }
      setLoading(false);
    }, [dispatch, fDocentete.doPiece, t, token]);

    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {(!canEditBonDeCommande(fDocentete, user) || !isUserBonDeCommande(user)) && (
          <>
            <LoadingButton
              variant="contained"
              sx={{ mt: 1 }}
              loading={loading}
              onClick={partialOrder}
              color="success"
            >
              {t("word.orderType." + ORDER_TYPE_PARTIAL.toLowerCase())}
            </LoadingButton>
            <Tooltip title={t("sentence.partialLivraison")}>
              <InfoIcon />
            </Tooltip>
          </>
        )}
      </Box>
    );
  }
);

export default FDocenteteParitalDeliveryComponent;
